export const AboutApplicationData = ["Customer First Content-focused Displaying Effects", "High Definition full-screen & Background", "Try for Free, Forever!"];

export const TeamExpertData = [1,2,3,4,2];

export const IconGoogleData = ["https://www.google.com/", "https://twitter.com/", "https://www.facebook.com/"];

export const TemplateFeaturesData = [
  { image: "5", title: "Color and font variety choices", text: "Effortlessly modify colors and fonts, or select from available choices." },
  { image: "6", title: "RTL Support", text: "Design your website LTR or RTL, it supports multi-languages so its easy to design website on any layout such as arabic, urdy..." },
  { image: "7", title: "Dark extension", text: "Extension methods add functionality to existing libraries. it suggests extension methods alongside regular methods." },
];

export const PricePlanData = [
  {
    plan: "Advanced",
    price: "$90.00",
    description: "Instant message delivery. Typing indicators to show when the other party is typing.",
    features: ["Chat Support", "Integration With CRM", "Customer Service Priority"],
    image: "landing/pricing-plan/2.png",
    buttonText: "Get Started",
  },
  {
    plan: "Free Plan",
    price: "$70.00",
    description: "Responsive design for various devices (desktop, tablet, mobile).",
    features: ["Concurrent Chats", "File Sharing", "Custom Branding"],
    image: "landing/pricing-plan/1.png",
    buttonText: "Get Started",
  },
  {
    plan: "Professional",
    price: "$110.00",
    description: "Ability to send and receive images, files, and other multimedia.",
    features: ["Multi-language Support", "Chat History Storage", "Security features"],
    image: "landing/pricing-plan/3.png",
    buttonText: "Get Started",
  },
  {
    plan: "Free Plan",
    price: "$70.00",
    description: "Responsive design for various devices (desktop, tablet, mobile).",
    features: ["Concurrent Chats", "File Sharing", "Custom Branding"],
    image: "landing/pricing-plan/1.png",
    buttonText: "Get Started",
  },
];
